import React, { useRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

//Animation
import { useAutoAnimate } from '@formkit/auto-animate/react'

//Toast
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Skeleton
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

//ICONS
import { BsCheck2Circle, BsCalendar3 } from "react-icons/bs";

//APIS
import { ogrenciBilgi } from '../../../apis/ogrenci';
import { donemAktif } from '../../../apis/donem';
import { seminerCreate } from '../../../apis/seminer';

const YeniBasvuru = () => {
    const navigate = useNavigate()
    const reduxData = useSelector((state) => state.auth)
    //console.log(reduxData)

    const [animationParent] = useAutoAnimate()
    const [loading, setLoading] = useState(false) // Skleton için kullanılacak

    //REFS
    const sunumSekliRef = useRef()
    const sunumTarihiRef = useRef()
    const sunumSaatiRef = useRef()
    const sunumYeriRef = useRef()
    const sunumKonusuRef = useRef()


    //STATES

    const [sunumSekli, setSunumSekli] = useState("Yüz yüze")
    const [sunumTarihi, setSunumTarihi] = useState("")
    const [sunumSaati, setSunumSaati] = useState("")
    const [sunumYeri, setSunumYeri] = useState("")
    const [sunumKonusu, setSunumKonusu] = useState("")


    //STATES LIST
    const [ogrenciLIST, setOgrenciLIST] = useState([])
    const [aktifDonem, setAktifDonem] = useState(false)


    // Öğrenci akademik bilgilerini girmiş mi?
    // Öğrenci danışman seçmiş mi?
    // Aktif Dönem var mı?


    //HANDLE FUNCTIONS

    const handleFormControl = () => {

        if (sunumTarihi === "") {
            sunumTarihiRef.current.focus()
            return toast.error("Sunumuzunu yapacağınız tarihi giriniz", {
                position: toast.POSITION.TOP_CENTER
            });
        }
        if (sunumSaati === "") {
            sunumSaatiRef.current.focus()
            return toast.error("Sunumuzunu yapacağınız saati giriniz", {
                position: toast.POSITION.TOP_CENTER
            });
        }
        if (sunumYeri === "") {
            sunumYeriRef.current.focus()
            return toast.error("Sunumuzunu yapacağınız yeri giriniz", {
                position: toast.POSITION.TOP_CENTER
            });
        }
        if (sunumKonusu === "") {
            sunumKonusuRef.current.focus()
            return toast.error("Seminer konunuzu giriniz", {
                position: toast.POSITION.TOP_CENTER
            });
        }

        handleFormSave()
    }

    const handleFormSave = async () => {
        let data = {
            donemId: aktifDonem.donemId,
            ogrenciId: ogrenciLIST.ogrenciId,
            danismanId: ogrenciLIST.danismanId,
            enstituId: ogrenciLIST.enstituId,
            enstituName: ogrenciLIST.enstitu.enstituName,
            anabilimName: ogrenciLIST.anabilim.anabilimName,
            bilimsanatdaliName: ogrenciLIST.bilimsanatdali ? ogrenciLIST.bilimsanatdali?.bilimsanatdaliName : "",
            seminerProgrami: ogrenciLIST.ogrenciProgram,
            seminerTuru: sunumSekli,
            seminerTarihi: sunumTarihi,
            seminerSaati: sunumSaati,
            seminerYeri: sunumYeri.trim(),
            seminerKonusu: sunumKonusu.trim()
        }

        let result = await seminerCreate(data)
        console.log(result)
        if (result.status === 201) {
            navigate('/seminer-print/' + result.data.seminerCode, { state : { durum : "ok" } })
        } else {
            toast.warning(result.response.data.message, {
                position: toast.POSITION.TOP_CENTER
            });
        }

    }


    //API FUNCTIONS
    const getOgrenciLIST = async () => {
        let result = await ogrenciBilgi()
        if (result.status === 200) {
            setOgrenciLIST(result.data.ogrenci)
        }
    }

    const getDonemAktif = async () => {
        setLoading(true)
        let result = await donemAktif()
        if (result.status === 200) {
            setAktifDonem(result.data.donemActive)
            getOgrenciLIST()
            setLoading(false)
        }else{
            setLoading(false)
        }
    }

    useEffect(() => {
        getDonemAktif()
        // eslint-disable-next-line
    }, []);




    return (
        <>
            <ToastContainer />
            <main className='text-slate-500 text-sm transition-all'>
                <div className="py-5">
                    <div className="w-full px-4 sm:px-6 md:px-8">
                        <div className='container mx-auto'>
                            <h1 className='page-title leading-6 font-normal text-lg mb-6 text-slate-500 '>Seminer Başvuru Formu</h1>
                        </div>
                        <div className='container mx-auto space-y-4'>
                            <div className='kapsama relative w-full flex flex-col lg:flex-row gap-4'>

                                {/* SEMİNER BAŞVURU FORMU */}
                                <div className='sag w-full'>
                                    <div className='bg-white rounded-lg p-4 min-h-0'>
                                        {/* ALERT */}
                                        <div ref={animationParent}>
                                            {
                                                loading ? <Skeleton baseColor="#e2e8f0" width="100%" count={3} height={20} /> : (
                                                    aktifDonem === false ? (
                                                        <div className="flex w-full overflow-hidden bg-white rounded-lg border border-slate-100">
                                                            <div className="flex items-center justify-center w-14 bg-red-500">
                                                                <svg className="w-6 h-6 text-white fill-current" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M20 3.36667C10.8167 3.36667 3.3667 10.8167 3.3667 20C3.3667 29.1833 10.8167 36.6333 20 36.6333C29.1834 36.6333 36.6334 29.1833 36.6334 20C36.6334 10.8167 29.1834 3.36667 20 3.36667ZM19.1334 33.3333V22.9H13.3334L21.6667 6.66667V17.1H27.25L19.1334 33.3333Z" />
                                                                </svg>
                                                            </div>

                                                            <div className="px-4 py-2 -mx-3">
                                                                <div className="mx-3">
                                                                    <span className="font-semibold text-red-500 ">Üzgünüz!</span>
                                                                    <p className="text-sm text-gray-600 ">
                                                                        Senimer başvuru formu için aktif dönem bulunmamaktadır.
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <>
                                                            {
                                                                ogrenciLIST?.ogrenciProgram === null || ogrenciLIST?.anabilimId === null || ogrenciLIST?.danismanId === null ? (
                                                                    <>
                                                                        <div className="flex w-full overflow-hidden bg-white rounded-lg border border-slate-100 mb-4">
                                                                            <div className="flex items-center justify-center w-14 bg-blue-400">
                                                                                <svg className="w-6 h-6 text-white fill-current" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                                                                                    <path d="M20 3.33331C10.8 3.33331 3.33337 10.8 3.33337 20C3.33337 29.2 10.8 36.6666 20 36.6666C29.2 36.6666 36.6667 29.2 36.6667 20C36.6667 10.8 29.2 3.33331 20 3.33331ZM21.6667 28.3333H18.3334V25H21.6667V28.3333ZM21.6667 21.6666H18.3334V11.6666H21.6667V21.6666Z" />
                                                                                </svg>
                                                                            </div>

                                                                            <div className="px-4 py-2 -mx-3">
                                                                                <div className="mx-3">
                                                                                    <span className="font-semibold text-blue-500 ">Uyarı!</span>
                                                                                    <p className="text-sm text-gray-600 ">
                                                                                        Hesabınızda Anabilim/Anasanat dalı, Danışman vs. bilgilerinize erişemiyoruz. Lütfen <strong>"Hesabım"</strong> bölümünden gerekli bilgileri güncelleyiniz.
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <div className='text-slate-600 font-semibold flex flex-col items-center  gap-3 border-b pb-4 border-b-slate-100'>
                                                                            <div className='inline-flex items-center gap-3'>
                                                                                <BsCalendar3 className='text-lg' />
                                                                                Seminer Başvuru Dönemi
                                                                            </div>
                                                                            <p>{aktifDonem?.donemName}</p>
                                                                            <p className='text-xs'>{aktifDonem?.donemBasTar} - {aktifDonem?.donemBisTar}</p>
                                                                        </div>

                                                                        <div className=' mt-8 flex flex-col md:flex-row gap-4'>
                                                                            <div className='w-full md:w-4/12 p-4 rounded-lg bg-slate-50'>
                                                                                <img className='w-16 h-16 rounded-full mx-auto mb-4' src={process.env.PUBLIC_URL + 'images/odu.png'} alt='' />
                                                                                <h1 className='text-lg text-center font-semibold'>{reduxData.userName}</h1>
                                                                                <p className='mb-4 text-center'>{reduxData.userEnstituName}</p>
                                                                                <div className='flex justify-center items-center divide-x'>
                                                                                    <div className='p-3 text-center'>
                                                                                        <div className=''>T.C. Kimlik No</div>
                                                                                        <div className='font-semibold'>{ogrenciLIST?.ogrenciTC}</div>
                                                                                    </div>
                                                                                    <div className='p-3 text-center'>
                                                                                        <div>Öğrenci No</div>
                                                                                        <div className='font-semibold'>{ogrenciLIST?.ogrenciNo}</div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='w:8/12 flex flex-col gap-y-3 justify-center px-6'>
                                                                                <div className=''>
                                                                                    <p className='font-semibold'>Program</p>
                                                                                    <p className='indent-4'>{ogrenciLIST?.ogrenciProgram}</p>
                                                                                </div>
                                                                                <div className=''>
                                                                                    <p className='font-semibold'>Anabilim / Anasanat Dalı</p>
                                                                                    <p className='indent-4'>{ogrenciLIST?.anabilim?.anabilimName}</p>
                                                                                </div>
                                                                                <div>
                                                                                    <p className='font-semibold'>Bilim / Sanat Dalı</p>
                                                                                    <p className='indent-4'>{ogrenciLIST?.bilimsanatdali?.bilimsanatdaliName}</p>
                                                                                </div>
                                                                                <div>
                                                                                    <p className='font-semibold'>Danışman</p>
                                                                                    <p className='indent-4'>{ogrenciLIST?.danisman?.danismanUnvan} {ogrenciLIST?.danisman?.danismanAdSoyad}</p>
                                                                                </div>
                                                                                <div>
                                                                                    <p className='font-semibold'>İletişim</p>
                                                                                    <p className='indent-4'>E-Posta : {ogrenciLIST?.ogrenciEposta} - Telefon : {ogrenciLIST?.ogrenciCepNo}</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div className='mt-6 border rounded-md p-4'>
                                                                            <h1 className='font-semibold text-slate-600 mb-4'>Seminer Bilgieri</h1>
                                                                            <div className='flex flex-col md:flex-row gap-4'>
                                                                                <div className='flex-1'>
                                                                                    <label>Sunum Şekli</label>
                                                                                    <select ref={sunumSekliRef} onChange={(e) => setSunumSekli(e.target.value)} className='sd-form-input'>
                                                                                        <option value="Yüz yüze">Yüz yüze</option>
                                                                                        <option value="Çevrimiçi">Çevrimiçi</option>
                                                                                    </select>
                                                                                </div>
                                                                                <div ref={sunumTarihiRef} onChange={(e) => setSunumTarihi(e.target.value)} className='flex-1'>
                                                                                    <label>Tarihi</label>
                                                                                    <input className='sd-form-input' type='date' />
                                                                                </div>
                                                                                <div ref={sunumSaatiRef} onChange={(e) => setSunumSaati(e.target.value)} className='flex-1'>
                                                                                    <label>Saati</label>
                                                                                    <input className='sd-form-input' type='time' />
                                                                                </div>

                                                                            </div>
                                                                            <div className='flex flex-col gap-4 mt-2'>
                                                                                <div ref={sunumYeriRef} onChange={(e) => setSunumYeri(e.target.value)} className=''>
                                                                                    <label>Seminerin Yapılacağı Yer</label>
                                                                                    <input className='sd-form-input' type='text' />
                                                                                </div>
                                                                                <div ref={sunumKonusuRef} onChange={(e) => setSunumKonusu(e.target.value)} className='flex-1'>
                                                                                    <label>Seminer Konusu</label>
                                                                                    <textarea className='sd-form-input h-20'></textarea>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div>
                                                                            <button
                                                                                onClick={() => handleFormControl()}
                                                                                className='mt-4 text-xs h-10 inline-flex items-center gap-x-2 text-white bg-slate-500 disabled:bg-slate-300 hover:bg-slate-500/80 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all'>
                                                                                <BsCheck2Circle className='text-lg' />
                                                                                KAYDET
                                                                            </button>
                                                                        </div>
                                                                    </>
                                                                )
                                                            }


                                                        </>
                                                    )
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </main>
        </>
    );
}

export default YeniBasvuru;
